export default __webpack_public_path__ + "static/media/logo_going_padrao.4cc710a9.jpg";